import { Avatar } from "@mui/material";
import { getDisplayInitials } from "@shared/helpers/user-initials";
import { profileImageSrcForBrowser } from "@shared/helpers/profile-image-client";
import clsx from "clsx";
import { type FC, useEffect, useState } from "react";

interface ImageLoadedProps {
  className?: string;
  styleObject?: React.CSSProperties;
  imageId: string | undefined;
  alt?: string;
}

export const ImageLoaded: FC<ImageLoadedProps> = ({
  imageId,
  styleObject,
  className,
  alt,
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageId]);

  const initials = getDisplayInitials(alt);
  const src =
    imageFailed || !imageId
      ? undefined
      : imageId.startsWith("/")
        ? imageId
        : profileImageSrcForBrowser(imageId);

  return (
    <Avatar
      className={clsx(className)}
      style={styleObject}
      src={src}
      imgProps={{
        onError: () => setImageFailed(true),
      }}
      alt={alt}
      sx={{ fontSize: "small" }}
    >
      {initials}
    </Avatar>
  );
};
